
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4 12a8 8 0 1116 0 8 8 0 01-16 0zm11.684-5L17 8.316 13.316 12 17 15.684 15.684 17 12 13.316 8.316 17 7 15.684 10.684 12 7 8.316 8.316 7 12 10.684 15.684 7z","fill":"currentColor"}})])
          )
        }
      }
    